import { Component } from 'react';
import PropTypes from 'prop-types';
import './ErrorBoundary.css';

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled error in app tree:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="eb-root">
          <h1 className="eb-title">Something went wrong</h1>
          <p className="eb-sub">Please rescan your QR code or try again.</p>
          <button type="button" className="eb-btn" onClick={this.handleReload}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
